import Vue from "vue";
import store from "@/store";

function logStandardErrorMessage( error ) {
	let errorMessage = "An unknown problem occurred. You can try again in a moment or try refreshing the page.";

	if ( error
		&& error.response
		&& error.response.data
		&& error.response.data.message
	) {
		errorMessage = error.response.data.message;
	}

	return store.commit( "toasts/SHOW", {
		color: "error",
		text: errorMessage
	} );
}

function handleNetworkError() {
	return store.commit( "toasts/SHOW", {
		color: "error",
		text: "A network error occurred. Check your internet connection or try again in a moment."
	} );
}

function handleRefreshCallError( error ) {
	if ( error.response.status === 401 ) {
		store.commit( "toasts/SHOW", {
			color: "error",
			text: "Please log in to view that page."
		} );
	}

	return store.dispatch( "auth/logout" );
}

function handleAuthCallError( error ) {
	logStandardErrorMessage( error );

	return Promise.reject( error );
}

async function handleApiCallError( error ) {
	if ( error.config._isAttemptAfterRefresh ) {
		logStandardErrorMessage( error );

		return Promise.reject( error );
	} else if ( error.response.status === 401 ) {
		try {
			const refreshResponse = await Vue.auth.refresh();

			if ( refreshResponse && refreshResponse.status === 200 ) {
				const config = error.config;

				// baseURL already prepended to url
				config.baseURL = "";

				config.headers.Authorization = `Bearer ${Vue.auth.token()}`;

				config._isAttemptAfterRefresh = true;

				return Vue.axios.request( config );
			}

			Vue.auth.token( null, null );
		} catch ( refreshError ) {
			Vue.auth.token( null, null );
		}
	}

	logStandardErrorMessage( error );

	return Promise.reject( error );
}

export default function handleError( error ) {
	const isNetworkError = error && error.message === "Network Error";
	const isRefreshCall = error.config.url.indexOf( Vue.auth.options.refreshData.url ) !== -1;
	const isAuthCall = error.config.url.indexOf( "/auth/" ) !== -1;

	if ( isNetworkError ) {
		return handleNetworkError( error );
	} else if ( isRefreshCall ) {
		return handleRefreshCallError( error );
	} else if ( isAuthCall ) {
		return handleAuthCallError( error );
	}

	return handleApiCallError( error );
}
